export default __webpack_public_path__ + "static/PopupBackground2-9a6522dc1cf3852dd3d25e1fb1b01a50.webp";